import axios from 'axios'

// Dedicated axios instance for the Betkotip calculators API
// (Betkotip/apps/api — metered, API-key protected, separate from the main
// Betko backend used by config/axios.js).
//
// Env:
//   REACT_APP_CALC_API_URL  base URL of the calculators API (e.g. http://localhost:3000)
//   REACT_APP_CALC_API_KEY  the API key issued for this frontend
//
// NOTE: per product decision the key ships in the public bundle, so metering
// against it is "best effort". Do not put a high-quota/admin key here.

const BASE_URL = process.env.REACT_APP_CALC_API_URL || 'http://localhost:3000'
const API_KEY = process.env.REACT_APP_CALC_API_KEY || ''

if (!API_KEY && process.env.NODE_ENV !== 'test') {
  // eslint-disable-next-line no-console
  console.warn(
    '[calculatorsApi] REACT_APP_CALC_API_KEY is not set — calculator API calls will be rejected (401).'
  )
}

const calculatorsApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    ...(API_KEY ? { Authorization: `Bearer ${API_KEY}` } : {}),
  },
})

export default calculatorsApi
